import { CreateOrganizationInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from 'shared/services/axios';

export type CreateOrganizationRestResponse = { individualPartyId: string; organizationPartyId: string; relnId: string };

export type CreateOrganizationRestInput = Omit<CreateOrganizationInput, 'taxId' | 'isTaxIdSsn' | 'isTaxExempt'> & {
  taxId?: string;
  ssn?: string;
};

export async function createOrganizationRest(
  input: CreateOrganizationRestInput,
): Promise<CreateOrganizationRestResponse> {
  const response = await api.post<CreateOrganizationRestResponse>(apiEndpoints.createOrganization, input);
  return response.data;
}
